<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BKngXu/tc-custom/cover.jpg?1684306038352?1692614730325" alt="This image is the cover for the book Carne: Parte Nove"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carne: Parte Nove
      </h1>
      <p class="bookDescription body article font2">
        <p>Il segreto delle immagini rifiutate viene finalmente rivelato e avvicina Lucian e Amy più che mai. Le cose sembrano prendere una svolta nella loro relazione mentre lui le mostra che può essere vulnerabile. Tuttavia, nessun uomo può cambiare così drasticamente in una sola notte.<br/> Amy aveva sperato che i suoi amici sarebbero stati entusiasti di questa nuova svolta degli eventi. Derrick sarebbe stato sconvolto. Era scontato. Tuttavia, Amy non si sarebbe mai aspettata la reazione di Janice.<br/> Solo il tempo dirà se Lucian è stato sincero quando ha confessato i suoi sentimenti, o se sta solo giocando a un altro gioco di manipolazione.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sky Corgan, Daniele Giuffrè
      </h2>
      
      <p class="authorDescription body article">Sky Corgan è l'autorice più venduta secondo USA Today di The Billionaires Club. Vive in una piccola città vicino a San Antonio, in Texas. Quando non sta scrivendo a macchina il prossimo romanzo rosa bollente, è impegnata a pianificare le vacanze future.<br/> Originariamente un'autrice dell'orrore, scene di sesso e storie d'amore hanno continuato a insinuarsi magicamente nel suo lavoro, quindi ha deciso di passare al romanticismo. Ora le piace scrivere storie che ti fanno battere il cuore e risvegliare i tuoi desideri interiori.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29bc5511